export function isImpersonating() {
	return document.cookie.includes('is_impersonating');
}
